//https://react-chartjs-2.js.org/examples/vertical-bar-chart
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

const ComponentBarChart = (props) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const { labels, datasets, titleGraphe, stacked } = props;

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: titleGraphe,
      },
    },
  };

  const optionsStacked = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: titleGraphe,
      },
    },

    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const datas = {
    labels,
    datasets: datasets,
  };

  return <Bar options={stacked ? optionsStacked : options} data={datas} />;
};

export default ComponentBarChart;
